import { AxiosResponse } from 'axios'

// realisations
import { http } from '../realisations/Http.realisation'

// types
import {
    DeliveryCompanyPayload,
    GetBillingDeliveryCompaniesResponse,
    GetDeliveryCompaniesParams,
    GetDeliveryCompaniesResponse,
    GetDeliveryCompanyResponse,
    GetBillingDeliveryCompaniesParams,
} from '@/core/types/delivery-companies.types'

export class DeliveryCompaniesRepository {
    getCompanies(
        params: GetDeliveryCompaniesParams
    ): Promise<AxiosResponse<GetDeliveryCompaniesResponse>> {
        return http.get('/order/api/v1/call-center/companies', { params })
    }

    getCompany(company_id: number): Promise<AxiosResponse<GetDeliveryCompanyResponse>> {
        return http.get(`/order/api/v1/call-center/companies/${company_id}`)
    }

    createCompany(payload: FormData): Promise<AxiosResponse<void>> {
        return http.postFormData('/order/api/v1/call-center/companies', payload)
    }

    updateCompany(
        company_id: number,
        payload: DeliveryCompanyPayload
    ): Promise<AxiosResponse<void>> {
        return http.put(`/order/api/v1/call-center/companies/${company_id}`, payload)
    }

    deleteCompany(company_id: number): Promise<AxiosResponse<void>> {
        return http.delete(`/order/api/v1/call-center/companies/${company_id}`)
    }

    getBillingCompanies(
        params: GetBillingDeliveryCompaniesParams
    ): Promise<AxiosResponse<GetBillingDeliveryCompaniesResponse>> {
        return http.get('/billing/api/delivery/delivery-companies', { params })
    }
}
